import React, { useEffect, useReducer, useRef, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";
import moment from 'moment';


import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import Input from './Input';
import Radios from './Radios';
import Profiles from './Profiles';
import { close, loadingflas, open, listupdater } from '../redux/popupSlice';
import Select from './Select';
import DaumPostcode from 'react-daum-postcode';
import { getBase64, getMemberinfo, regPhone } from '../utils/utils';
import * as APIS from "../utils/service";

import Checkbox from './Checkbox';
import AddrSelector from './AddrSelector';
import InputDate from './InputDate';
import PolicyContents from './PolicyContents';


export default function QuetionSimpleWrite(props) {

    const {
        setView,
        setsimplewrite = () => { },
        setselltypeproduct = () => { },
        setcategory_1product = () => { },
        setcategory_2product = () => { },
        memberinfos = {}
    } = props;

    const { configdata } = useSelector(s => s.configReducer);
    const selectFile = useRef(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    let firstCategorys = configdata?.consts?.category_1_OptionConsts?.find((x, i) => i === 0)?.idx;


    // 신규 state
    const [quetion_type, setquetion_type] = useState(1); // 1=매물내놓기, 2=구해주세요

    const [timerflag, settimerflag] = useState(false);
    const [phone, setphone] = useState('');
    const [secretnum, setsecretnum] = useState('');
    const [quetion_check, setquetion_check] = useState(false);
    // const [quetion_check, setquetion_check] = useState([]);
    const [quetion_check2, setquetion_check2] = useState([]);
    const [listselecterviewerlist, setlistselecterviewerlist] = useState([]);
    const [isOpenPost, setIsOpenPost] = useState(false); // 주소 찾기 열기
    const [isAddr, setIsAddr] = useState(false);


    // const [reallistselecterviewerlist, setreallistselecterviewerlist] = useState([]); // 실제 검색 조건에 등록한 주소지
    /////////////////////////////////////////////////////

    //인증번호
    const [authNum, setauthNum] = useState("");
    const [authCheck, setauthCheck] = useState(false);

    // 팔아주세요 구해주세요 공통 state
    const [sell_type, setsell_type] = useState('매매'); // 거래형태
    const [category_1, setcategory_1] = useState(firstCategorys); // 매물종류 1차분류
    const [category_2, setcategory_2] = useState(configdata?.consts?.category_2_OptionConsts?.find((x, i) => (x?.category_1 === firstCategorys && i === 0))?.idx); // 매물종류 2차분류


    // 팔아주세요 state
    const [addrDatas, setaddrDatas] = useState({}); // 소재지
    const [building_dong, setbuilding_dong] = useState(''); // 해당동
    const [building_floor, setbuilding_floor] = useState(''); // 해당층
    const [building_unit, setbuilding_unit] = useState(''); // 해당호
    const [price_sell, setprice_sell] = useState(''); //매매가
    const [now_price_all, setnow_price_all] = useState(''); //현보증금
    const [now_price_month, setnow_price_month] = useState(''); //현재월세
    const [price_all, setprice_all] = useState(''); //보증금
    const [price_month, setprice_month] = useState(''); //현재월세
    const [price_keymoney, setprice_keymoney] = useState(''); //권리금
    const [price_maintenance, setprice_maintenance] = useState(''); //관리비
    const [area_supply, setarea_supply] = useState(''); //공급면적
    const [area_contract, setarea_contract] = useState(''); //계약면적
    const [area_private, setarea_private] = useState(''); //전용면적
    const [building_count, setbuilding_count] = useState(''); //건물 수	
    const [building_floor_all, setbuilding_floor_all] = useState(''); //지상 총 층	
    const [building_floor_under_all, setbuilding_floor_under_all] = useState(''); //지하 총 층	
    const [area_land, setarea_land] = useState(''); //토지면적
    const [area_floor, setarea_floor] = useState(''); //연면적
    const [desc, setdesc] = useState(''); //특이사항



    const [pricesinputArr, setpricesinputArr] = useState([
        { default: true, inputstyle: 0, titles: '매매가', values: price_sell, setvaluesfunc: setprice_sell, input_type: 'number', viewtype: [1, 2, 3], viewtype2: ['매매'] },
        { default: false, inputstyle: 0, titles: '현보증금', values: now_price_all, setvaluesfunc: setnow_price_all, input_type: 'number', viewtype: [1, 2, 3], viewtype2: ['매매'] },
        { default: false, inputstyle: 0, titles: '현재월세', values: now_price_month, setvaluesfunc: setnow_price_month, input_type: 'number', viewtype: [1, 2, 3], viewtype2: ['매매'] },
        { default: true, inputstyle: 0, titles: '보증금', values: price_all, setvaluesfunc: setprice_all, input_type: 'number', viewtype: [1, 2, 3], viewtype2: ['전세', '월세'] },
        { default: true, inputstyle: 0, titles: '월세', values: price_month, setvaluesfunc: setprice_month, input_type: 'number', viewtype: [1, 2, 3], viewtype2: ['월세'] },
        { default: false, inputstyle: 0, titles: '권리금', values: price_keymoney, setvaluesfunc: setprice_keymoney, input_type: 'number', viewtype: [2, 3], viewtype2: ['매매', '전세', '월세'] },
        { default: true, inputstyle: 0, titles: '관리비', values: price_maintenance, setvaluesfunc: setprice_maintenance, input_type: 'number', viewtype: [1, 2, 3], viewtype2: ['매매', '전세', '월세'] },
    ]);


    // 구해주세요 state
    const [title, settitle] = useState(''); //고객명칭
    const [price_all_min, setprice_all_min] = useState(''); // 희망매매가 보증금or거래가격 최소
    const [price_all_max, setprice_all_max] = useState(''); // 희망매매가 보증금or거래가격 최대
    const [price_month_min, setprice_month_min] = useState(''); //월세 최소
    const [price_month_max, setprice_month_max] = useState(''); //월세 최대
    const [price_key_min, setprice_key_min] = useState(''); //권리금 최소
    const [price_key_max, setprice_key_max] = useState(''); //권리금 최대
    const [price_real, setprice_real] = useState(''); // 실 투자금
    const [item_floor_min, setitem_floor_min] = useState(''); // 희망층수 최소(지하는 -1 ~)
    const [item_floor_max, setitem_floor_max] = useState(''); // 희망층수 최대
    const [item_area_min, setitem_area_min] = useState(''); // 희망면적 최소
    const [item_area_max, setitem_area_max] = useState(''); // 희망면적 최대
    const [item_year_min, setitem_year_min] = useState(''); // 희망연식 최소 (YYYY)
    const [item_year_max, setitem_year_max] = useState(''); // 희망연식 최댜 (YYYY)
    const [in_year, setin_year] = useState(''); // 입주시기
    const [dateerrmsg, setdateerrmsg] = useState('');
    const [checkvalues, setcheckvalues] = useState([]);
    const [memo, setmemo] = useState("");
    const [polylist, setpolylist] = useState([]);

    const [in_year_option1, setin_year_option1] = useState(false); //협의가능 true,false,
    const [in_year_option2, sestin_year_option2] = useState(false); //상관없음 true,false,
    // const [detailwrite, setdetailwrite] = useState('');
    // const [hp, sethp] = useState([]);



    let category_1_setting = configdata?.consts?.category_1_OptionConsts?.map((x, i) => {
        return { labels: x?.title, values: x?.idx }
    })
    let category_2_setting = configdata?.consts?.category_2_OptionConsts?.map((x, i) => {
        return { labels: x?.title, values: x?.idx, category_1: x?.category_1 }
    })
    const [category_1_OptionConsts, setcategory_1_OptionConsts] = useState(category_1_setting);
    // const [category_2_OptionConsts, setcategory_2_OptionConsts] = useState(category_2_setting);


    const [errmsg, seterrmsg] = useState('');
    const [errmsghp, seterrmsghp] = useState('');
    const [errmsg2, seterrmsg2] = useState('');
    const [client_name, setclient_name] = useState(''); // 의뢰인
    const [client_hp, setclient_hp] = useState(''); //연락처

    const [files, setfiles] = useState([]);


    useEffect(() => {
        dispatch(loadingflas({ loading: false }));
        document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'hidden';
        return () => {
            document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'scroll';
        }
    }, []);


    useEffect(() => {
        seterrmsg('');
    }, [
        sell_type, category_1, category_2, addrDatas, building_dong, building_floor, building_unit,
        price_sell, now_price_all, now_price_month, price_all, price_month, price_keymoney, price_maintenance, price_maintenance,
        area_supply, area_contract, area_private, building_count, building_floor_all, building_floor_under_all, area_land, area_floor,
        client_name, client_hp, desc, files
    ]);

    useEffect(() => {
        setcategory_2(category_2_setting?.filter((x2, i2) => (x2.category_1 * 1 === category_1 * 1))[0]?.values);
    }, [category_1]);

    const onCompletePost = (data) => {
        let fullAddr = data.address;
        let extraAddr = '';

        //console.log('data', data);

        //let jibunAddress = jibunAddress;

        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddr += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddr += extraAddr !== '' ? `, ${data.buildingName}` : data.buildingName;
            }
            fullAddr += extraAddr !== '' ? ` (${extraAddr})` : '';
        }
        console.log(data);

        setaddrDatas({
            addr: data.address,
            sido: data?.sido,
            sigungu: data?.sigungu || data?.sido,
            dong: data?.bname1 || data?.bname
        });

        setIsOpenPost(false);
    };

    const postBoxStyle = {
        display: 'block',
        position: 'relative',
        width: '100%',
        border: '1px solid #000',
        marginTop: 5,
        textAlign: 'right'
    };

    const postCodeStyle = {
        width: '100%',
        borderTop: '1px solid #000',
    };

    const simpleWirteSubmit = (uidx = null, removed = false) => {

        // sell_type, category_1, category_2, addrDatas, building_dong, building_floor, building_unit,
        // price_sell, now_price_all, now_price_month, price_all, price_month, price_keymoney, price_maintenance, price_maintenance,
        // area_supply, area_contract, area_private, building_count, building_floor_all, building_floor_under_all, area_land, area_floor,
        // client_name, client_hp
        //console.log("addrDatas", addrDatas);
        let inputsdefaultsArr = [
            { values: sell_type, comments: '거래형태를', comment_types: '선택' },
            { values: category_1, comments: '매물종류를', comment_types: '선택' },
            { values: category_2, comments: '하위매물종류를', comment_types: '선택' },
            { values: addrDatas?.sido || '', comments: '소재지를', comment_types: '검색' },
            { values: addrDatas?.sigungu || '', comments: '소재지를', comment_types: '검색' },
            { values: addrDatas?.dong || '', comments: '소재지를', comment_types: '검색' },
            { values: addrDatas?.addr || '', comments: '소재지를', comment_types: '검색' },
            // category_1*1 !== 3 && {values: building_dong, comments: '해당동을', comment_types: '입력'},
            // category_1*1 !== 3 && {values: building_floor, comments: '해당층을', comment_types: '입력'},
            // category_1*1 !== 3 && {values: building_unit, comments: '해당호를', comment_types: '입력'},
            sell_type === '매매' && { values: price_sell, comments: '매매가를', comment_types: '입력' },
            // sell_type === '매매' && {values: now_price_all, comments: '현보증금를', comment_types: '입력'},
            // sell_type === '매매' && {values: now_price_month, comments: '현재월세를', comment_types: '입력'},
            (sell_type === '전세' || sell_type === '월세') && { values: price_all, comments: '보증금을', comment_types: '입력' },
            (sell_type === '월세') && { values: price_month, comments: '월세를', comment_types: '입력' },
            //category_1*1 === 2 && {values: price_keymoney, comments: '권리금을', comment_types: '입력'},
            { values: price_maintenance, comments: '관리비 를', comment_types: '입력' },
            //(category_1*1 !== 3 && (category_2*1 === 1 || category_2*1 === 2 || category_2*1 === 3)) && {values: area_supply, comments: '공급면적을', comment_types: '입력'},
            //(category_1*1 !== 3 && (category_2*1 === 4 || category_2*1 === 5 || category_2*1 === 6 || category_2*1 === 7 || category_2*1 === 8)) && {values: area_contract, comments: '계약면적을', comment_types: '입력'},
            //category_1*1 !== 3 && {values: area_private, comments: '전용면적 를', comment_types: '입력'},
            //category_1*1 === 3 && {values: building_count, comments: '건물 수를', comment_types: '입력'},
            //category_1*1 === 3 && {values: building_floor_all, comments: '지상 총 층을', comment_types: '입력'},
            //category_1*1 === 3 && {values: building_floor_under_all, comments: '지하 총 층을', comment_types: '입력'},
            //category_1*1 === 3 && {values: area_land, comments: '토지면적을', comment_types: '입력'},
            //category_1*1 === 3 && {values: area_floor, comments: '연면적을', comment_types: '입력'},
            { values: client_hp, comments: '연락처를', comment_types: '입력' },
        ];
        //console.log('???', building_floor_under_all);
        for (let c = 0; c < inputsdefaultsArr?.length; c++) {
            if (inputsdefaultsArr[c]?.values === '') {
                seterrmsg(`${inputsdefaultsArr[c]?.comments} ${inputsdefaultsArr[c]?.comment_types}해주세요.`);
                return;
            }
        }

        if(!authCheck){
            seterrmsg("연락처 인증을 해주세요.");
            return;
        }

        if(!quetion_check){
            seterrmsg("필수항목에 동의해주세요.");
            return;
        }

        let fileSetting = [];
        files?.map((x, i) => {
            fileSetting.push({ base: x?.base64, ext: x?.ext });
        });

        let sender = {
            idx: uidx,
            sell_type: sell_type,
            title: '',
            category_1: category_1*1,
            category_2: category_2*1,
            sido: addrDatas?.sido,
            sigungu: addrDatas?.sigungu,
            dong: addrDatas?.dong,
            addr: addrDatas?.addr,
            price_sell: price_sell * 1,
            now_price_all: now_price_all * 1,
            now_price_month: now_price_month * 1,
            price_all: price_all * 1,
            price_month: price_month * 1,
            price_keymoney: price_keymoney * 1,
            price_maintenance: price_maintenance * 1,
            area_supply: area_supply,
            area_contract: area_contract,
            area_private: area_private,
            area_land: area_land,
            area_floor: area_floor,
            building_dong: building_dong,
            //building_dong_floor_all: building_dong_floor_all,
            building_floor: building_floor,
            building_unit: building_unit,
            building_count: building_count,
            building_floor_all: building_floor_all,
            building_floor_under_all: building_floor_under_all,
            //building_unit_all: building_unit_all,
            //building_unit_empty: building_unit_empty,
            //item_direction: item_direction,
            //item_direction_standard: item_direction_standard,
            //item_room: item_room,
            //item_bathroom: item_bathroom,
            //item_households: item_households,
            //item_car_all: item_car_all,
            //item_car: item_car,
            //item_elevator: item_elevator,
            //item_usage: item_usage,
            //item_date_type: item_date_type,
            //item_date: item_date,
            //item_move_date: item_move_date,
            client_name: client_name,
            client_hp: client_hp,
            desc: desc,
            files: [],
            delete_files: [],
            users: memberinfos
        }


        dispatch(
            open({
                component: '등록하시겠습니까?',
                title: '알림',
                button: "등록",
                buttonCencle: "취소",
                titleviewer: true,
                alert: false,
                onPress: () => {
                    dispatch(loadingflas({ loading: true }));
                    APIS.postData('/v1/item/insertmini', sender).then(({ data }) => {
                        if (data) {
                            dispatch(close());
                            dispatch(
                                open({
                                    component: '문의가 등록되었습니다.',
                                    title: '알림',
                                    titleviewer: true,
                                    alert: false,
                                    button: "확인",
                                    onPress: () => {
                                        dispatch(close());
                                        if (setView) setView();
                                    }
                                })
                            );
                        }
                    }).catch(({ response }) => {
                        const { data } = response;
                        console.log(response);
                        dispatch(
                            open({
                                component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                                title: '알림',
                                button: "확인",
                                titleviewer: true,
                                alert: false,
                                onPress: () => {
                                    dispatch(close());
                                    if (setView) setView();
                                },
                            })
                        );
                    }).finally(() => {
                        dispatch(loadingflas({ loading: false }));
                    });
                },
                onCancelPress: () => {
                    dispatch(close());
                }
            })
        );
    }
    const customerWirteSubmit = (uidx = null) => {

        // title, sell_type, category_1, category_2, price_all_min, price_all_max, price_month_min, price_month_max, price_key_min, price_key_max, 
        // price_real, item_floor_min, item_floor_max, item_area_min, item_area_max, item_year_min, item_year_max, in_year, hp,
        // memo, citys, listselecterviewerlist, polylist

        let citysArr = [];
        listselecterviewerlist?.map((x, i) => {
            //console.log(item, x?.viewernames, x?.viewernames?.includes('전체'));
            if (x?.viewernames?.includes('전체')) {
                citysArr.push({ type: 1, sido: x?.sido, sigungu: x?.sigungu, dong: '전체' });
            } else {
                citysArr.push({ type: 1, sido: x?.sido, sigungu: x?.sigungu, dong: x?.viewernames });
            }
        });
        polylist?.map((x, i) => {
            citysArr.push({ type: 2, sido: '', sigungu: '', dong: '', polygon: JSON.stringify(x?.points) });
        });

        //console.log(citysArr);

        let inputsdefaultsArr = [
            // { values: title, comments: '고객명칭을', comment_types: '입력' },
            { values: sell_type, comments: '거래형태를', comment_types: '선택' },
            { values: category_1, comments: '매물종류를', comment_types: '선택' },
            { values: category_2, comments: '하위매물종류를', comment_types: '선택' },
            { values: citysArr?.length < 1 ? '' : citysArr?.length, comments: '희망지역을', comment_types: '선택' },
            sell_type === '매매' && { values: price_all_min, comments: '희망매매가 최소금액을', comment_types: '입력' },
            sell_type === '매매' && { values: price_all_max, comments: '희망매매가 최대금액을', comment_types: '입력' },
            sell_type !== '매매' && { values: price_all_min, comments: '희망보증금 최소금액을', comment_types: '입력' },
            sell_type !== '매매' && { values: price_all_max, comments: '희망보증금 최대금액을', comment_types: '입력' },
            sell_type === '월세' && { values: price_month_min, comments: '희망월세 최소금액을', comment_types: '입력' },
            sell_type === '월세' && { values: price_month_max, comments: '희망월세 최대금액을', comment_types: '입력' },
            //{values: in_year, comments: '입주시기를', comment_types: '선택'},
            { values: client_hp, comments: '연락처를', comment_types: '입력' },
        ];
        for (let c = 0; c < inputsdefaultsArr?.length; c++) {
            if (inputsdefaultsArr[c]?.values === '') {
                seterrmsg(`${inputsdefaultsArr[c]?.comments} ${inputsdefaultsArr[c]?.comment_types}해주세요.`);
                return;
            }
        }

        // if(!authCheck){
        //     seterrmsg("연락처 인증을 해주세요.");
        //     return;
        // }

        if(!quetion_check){
            seterrmsg("필수항목에 동의해주세요.");
            return;
        }

        let sender = {
            idx: uidx,
            title: title,
            sell_type: sell_type,
            category_1: category_1,
            category_2: category_2,
            price_all_min: price_all_min * 1,
            price_all_max: price_all_max * 1,
            price_month_min: price_month_min * 1,
            price_month_max: price_month_max * 1,
            price_key_min: price_key_min * 1,
            price_key_max: price_key_max * 1,
            price_real: price_real * 1,
            item_floor_min: item_floor_min * 1,
            item_floor_max: item_floor_max * 1,
            item_area_min: item_area_min,
            item_area_max: item_area_max,
            item_year_min: item_year_min * 1,
            item_year_max: item_year_max * 1,
            in_year: in_year,
            in_year_option1: checkvalues?.filter(item => item?.values * 1 === 0)?.length > 0 ? true : false,
            in_year_option2: checkvalues?.filter(item => item?.values * 1 === 1)?.length > 0 ? true : false,
            hp: client_hp,
            memo: memo,
            citys: citysArr,
            users: memberinfos
        }

        //console.log(sender);
        //return;
        dispatch(
            open({
                component: `${uidx !== null ? '수정' : '등록'}하시겠습니까?`,
                title: '알림',
                button: "등록",
                buttonCencle: "취소",
                titleviewer: true,
                alert: false,
                onPress: () => {
                    dispatch(loadingflas({ loading: true }));
                    APIS.postData('/v1/customer/insertmini', sender).then(({ data }) => {
                        if (data) {
                            dispatch(close());
                            dispatch(
                                open({
                                    component: `문의가 ${uidx !== null ? '수정' : '등록'}되었습니다.`,
                                    title: '알림',
                                    titleviewer: true,
                                    alert: false,
                                    button: "확인",
                                    onPress: () => {
                                        dispatch(close());
                                        if (setView) setView();
                                    }
                                })
                            );
                        }
                    }).catch(({ response }) => {
                        const { data } = response;
                        console.log(response);
                        dispatch(
                            open({
                                component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                                title: '알림',
                                button: "확인",
                                titleviewer: true,
                                alert: false,
                                onPress: () => {
                                    dispatch(close());
                                    if (setView) setView();
                                },
                            })
                        );
                    }).finally(() => {
                        dispatch(loadingflas({ loading: false }));
                    });
                },
                onCancelPress: () => {
                    dispatch(close());
                }
            })
        );

    }
    let bottomText = [
        {
            title: '개인정보를 제공받는 자',
            text: '주식회사 에이피링스'
        },
        {
            title: '개인정보를 제공받는 자의 개인정보 이용 목적',
            text: '모두의 매물 서비스를 이용, 간편문의 작성 내용 중개업소쪽 전달'
        },
        {
            title: '제공하는 개인정보 항목',
            text: '휴대폰 번호'
        },
        {
            title: '개인정보를 제공받는 자의 개인정보 보유 및 이용기간',
            text: '서비스 목적 달성시까지'
        },
        {
            title: '서비스 이용을 위한 필수적인 동의이므로, 동의하지 않을 경우 본 서비스를 이용하실 수 없습니다.',
            text: ''
        }
    ]


    return (
        <>
            <div className='ProductDetailArea' style={{ zIndex: 1000 }}>
                <div>
                    <div className='ProductDetailAreaBG'
                    // onClick={() => {
                    //     setsimplewrite(false);
                    // }}
                    />

                    <div></div>
                    <div className="ProductSendDetailpop">
                        <div className="ProductpopTitle padding20" style={{ borderBottom: '1px solid #eee' }}>
                            <span>간편문의</span>
                            <button
                                onClick={() => {
                                    if (setView) setView();
                                }}
                            >
                                <img src="./images/icons/x.svg" />
                            </button>
                        </div>

                        {!isAddr ?
                            <div className="productInputarea padding32" style={{ position: 'relative' }}>

                                <div className='inquiry_type_div'>
                                    <Button
                                        buttonTxt={'팔아주세요'}
                                        className={`inquiry_type_div_btn ${quetion_type === 1 ? 'active' : ''}`}
                                        onPress={() => {
                                            setquetion_type(1);
                                            settimerflag(false);
                                        }}
                                    />
                                    <Button
                                        buttonTxt={'구해주세요'}
                                        className={`inquiry_type_div_btn ${quetion_type === 2 ? 'active' : ''}`}
                                        onPress={() => {
                                            setquetion_type(2);
                                            settimerflag(false);
                                        }}
                                    />
                                </div>

                                <div className='fontsize12' style={{ marginBottom: 8 }}>
                                    필수표시사항(<span className='colorF00'>*</span>)을 정확하게 입력해주세요.
                                </div>
                                {/* 팔아주세요 */}
                                {quetion_type === 1 ?
                                    <>
                                        <div className="inputviewtype1 ">
                                            <div>거래형태<span className='colorF00'>*</span></div>
                                            <div>
                                                {category_2 * 1 !== 3 &&
                                                    <Button buttonTxt={'매매'} className={`writeRadiobutton ${sell_type === '매매' ? 'active' : ''}`} onPress={() => {
                                                        // if(category_2*1 === 3){
                                                        //     setcategory_2(1) 
                                                        //     //return;
                                                        // }
                                                        setsell_type('매매')
                                                    }} />}
                                                <Button buttonTxt={'전세'} className={`writeRadiobutton ${sell_type === '전세' ? 'active' : ''}`} onPress={() => setsell_type('전세')} />
                                                <Button buttonTxt={'월세'} className={`writeRadiobutton ${sell_type === '월세' ? 'active' : ''}`} onPress={() => setsell_type('월세')} />
                                            </div>

                                        </div>
                                        {category_2 * 1 === 3 &&
                                            <div className="input_error">* 단독/다가구 매매는 건물-주거전용건물 탭을 이용하세요.</div>
                                        }
                                        <div className="inputviewtype1 ">
                                            <div>매물종류<span className='colorF00'>*</span></div>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <div style={{ width: 'calc(50% - 2px)' }}>
                                                    <Select
                                                        styles={{}}
                                                        setValues={setcategory_1}
                                                        values={category_1}
                                                        selectData={category_1_OptionConsts}
                                                    />
                                                </div>

                                                <div style={{ width: 'calc(50% - 2px)' }}>
                                                    <Select
                                                        styles={{}}
                                                        setValues={(e) => {
                                                            if (sell_type === '매매' && e * 1 === 3) {
                                                                setsell_type('전세');
                                                            }
                                                            setcategory_2(e);
                                                        }}
                                                        values={category_2}
                                                        selectData={category_2_setting?.filter((x, i) => x?.category_1 * 1 === category_1 * 1)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="inputviewtype1 ">
                                            <div>소재지<span className='colorF00'>*</span></div>

                                            <div>
                                                <div className='buttonWithTxt' style={{ marginTop: 0 }}>
                                                    <div>
                                                        <Button
                                                            styles={{ width: 100, height: 40 }}
                                                            className={'linenormalbutton'}
                                                            buttonTxt={quetion_type === 1 ? '주소찾기' : '지역선택'}
                                                            onPress={() => {
                                                                if (quetion_type === 1) {
                                                                    setIsOpenPost(true);
                                                                } else {
                                                                    setIsAddr(!isAddr);
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    <div>
                                                        {addrDatas?.addr}
                                                    </div>
                                                </div>

                                                {isOpenPost ? (
                                                    <div style={postBoxStyle}>
                                                        <button type="button" className="addrbtn exit_btn" onClick={() => setIsOpenPost(false)} style={{ padding: 10 }}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.79289C5.68342 5.40237 6.31658 5.40237 6.70711 5.79289L12 11.0858L17.2929 5.79289C17.6834 5.40237 18.3166 5.40237 18.7071 5.79289C19.0976 6.18342 19.0976 6.81658 18.7071 7.20711L13.4142 12.5L18.7071 17.7929C19.0976 18.1834 19.0976 18.8166 18.7071 19.2071C18.3166 19.5976 17.6834 19.5976 17.2929 19.2071L12 13.9142L6.70711 19.2071C6.31658 19.5976 5.68342 19.5976 5.29289 19.2071C4.90237 18.8166 4.90237 18.1834 5.29289 17.7929L10.5858 12.5L5.29289 7.20711C4.90237 6.81658 4.90237 6.18342 5.29289 5.79289Z" fill="#999999" />
                                                            </svg>
                                                        </button>
                                                        <DaumPostcode style={postCodeStyle} autoClose onComplete={onCompletePost} />
                                                    </div>
                                                ) : null}

                                            </div>
                                        </div>

                                        {(category_1 * 1 !== 3 && quetion_type === 1) &&
                                            <div className="inputviewtype2 ">
                                                <div></div>
                                                <div>
                                                    <div>
                                                        <div>
                                                            <span>동</span>
                                                            <Input
                                                                className={`inputs`}
                                                                rightplaceholder="동"
                                                                setValue={setbuilding_dong}
                                                                value={building_dong}
                                                                name="mb_phone"
                                                                zerostatus={true}
                                                                style={{
                                                                    paddingRight: 30, textAlign: 'right'
                                                                }}
                                                            />
                                                        </div>
                                                        <div>
                                                            <span>층</span>
                                                            <Input
                                                                className={`inputs`}
                                                                rightplaceholder="층"
                                                                setValue={setbuilding_floor}
                                                                value={building_floor}
                                                                name="mb_phone"
                                                                zerostatus={true}
                                                                style={{
                                                                    paddingRight: 30, textAlign: 'right'
                                                                }}
                                                            />
                                                        </div>
                                                        <div>
                                                            <span>호</span>
                                                            <Input
                                                                className={`inputs`}
                                                                rightplaceholder="호"
                                                                setValue={setbuilding_unit}
                                                                value={building_unit}
                                                                name="mb_phone"
                                                                zerostatus={true}
                                                                style={{
                                                                    paddingRight: 30, textAlign: 'right'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        }

                                        {pricesinputArr?.map((x, i) => {
                                            if (!x?.viewtype?.find((x) => x * 1 === category_1 * 1)) {
                                                return;
                                            }
                                            if (!x?.viewtype2?.find((x) => x === sell_type)) {
                                                return;
                                            }
                                            if (x?.titles === '권리금' && category_1 * 1 === 3 && category_2 * 1 !== 9) {
                                                return;
                                            }

                                            return (
                                                <div className="inputviewtype1 " key={i}>
                                                    <div>{x?.titles}{x?.default === true && <span className='colorF00'>*</span>}</div>
                                                    <div>
                                                        <Input
                                                            type={x?.input_type}
                                                            className={`inputs`}
                                                            rightplaceholder="만원"
                                                            placeholder=""
                                                            setValue={(e) => {
                                                                x?.setvaluesfunc(e);
                                                                setpricesinputArr(pricesinputArr?.map((x2, i2) => x2?.titles === x?.titles ? { ...x2, values: e } : x2));
                                                            }}
                                                            value={x?.values}
                                                            name={x?.titles}
                                                            zerostatus={true}
                                                            style={{
                                                                paddingRight: 40, textAlign: 'right'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        })}

                                        {category_1 * 1 !== 3 &&
                                            <div className="inputviewtype3 ">
                                                {(category_2 * 1 === 1 || category_2 * 1 === 2 || category_2 * 1 === 3) ?
                                                    <div>
                                                        <div>공급</div>
                                                        <div>
                                                            <Input
                                                                className={`inputs`}
                                                                rightplaceholder="㎡"
                                                                placeholder=""
                                                                setValue={setarea_supply}
                                                                value={area_supply}
                                                                name="mb_phone"
                                                                zerostatus={true}
                                                                style={{
                                                                    paddingRight: 32, textAlign: 'right'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    :
                                                    <div>
                                                        <div>계약</div>
                                                        <div>
                                                            <Input
                                                                className={`inputs`}
                                                                rightplaceholder="㎡"
                                                                placeholder=""
                                                                setValue={setarea_contract}
                                                                value={area_contract}
                                                                name="mb_phone"
                                                                zerostatus={true}
                                                                style={{
                                                                    paddingRight: 32, textAlign: 'right'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                }

                                                <div>
                                                    <div style={{ textAlign: 'right' }}>전용</div>
                                                    <div>
                                                        <Input
                                                            className={`inputs`}
                                                            rightplaceholder="㎡"
                                                            placeholder=""
                                                            setValue={setarea_private}
                                                            value={area_private}
                                                            name="mb_phone"
                                                            zerostatus={true}
                                                            style={{
                                                                paddingRight: 32, textAlign: 'right'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {category_1 * 1 === 3 &&
                                            <>
                                                <div className="inputviewtype2 ">
                                                    <div>건물정보<span className='colorF00'>*</span></div>
                                                    <div>
                                                        <div>
                                                            <div>
                                                                <Input
                                                                    className={`inputs`}
                                                                    leftplaceholder="건물수"
                                                                    setValue={setbuilding_count}
                                                                    value={building_count}
                                                                    name="mb_phone"
                                                                    zerostatus={true}
                                                                    style={{
                                                                        paddingLeft: 0, textAlign: 'right'
                                                                    }}
                                                                />
                                                            </div>
                                                            <div>
                                                                <Input
                                                                    className={`inputs`}
                                                                    leftplaceholder="지상총층"
                                                                    setValue={setbuilding_floor_all}
                                                                    value={building_floor_all}
                                                                    name="mb_phone"
                                                                    zerostatus={true}
                                                                    style={{
                                                                        paddingLeft: 0, textAlign: 'right'
                                                                    }}
                                                                />
                                                            </div>
                                                            <div>
                                                                <Input
                                                                    className={`inputs`}
                                                                    leftplaceholder="지하총층"
                                                                    setValue={setbuilding_floor_under_all}
                                                                    value={building_floor_under_all}
                                                                    name="mb_phone"
                                                                    zerostatus={true}
                                                                    style={{
                                                                        paddingLeft: 0, textAlign: 'right'
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="inputviewtype3 ">
                                                    <div>
                                                        <div>토지면적<span className='colorF00'>*</span></div>
                                                        <div>
                                                            <Input
                                                                className={`inputs`}
                                                                rightplaceholder="㎡"
                                                                placeholder=""
                                                                setValue={setarea_land}
                                                                value={area_land}
                                                                name="mb_phone"
                                                                zerostatus={true}
                                                                style={{
                                                                    paddingRight: 32, textAlign: 'right'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div style={{ textAlign: 'right' }}>연면적<span className='colorF00'>*</span></div>
                                                        <div>
                                                            <Input
                                                                className={`inputs`}
                                                                rightplaceholder="㎡"
                                                                placeholder=""
                                                                setValue={setarea_floor}
                                                                value={area_floor}
                                                                name="mb_phone"
                                                                zerostatus={true}
                                                                style={{
                                                                    paddingRight: 32, textAlign: 'right'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }

                                        <div className="inquiry_number_div">
                                            <div className='title'>연락처</div>

                                            <div className='inquiry_number_input_div'>
                                                <Input
                                                    className={`inputs`}
                                                    setValue={(v) => {
                                                        seterrmsghp("");
                                                        setclient_hp(v)
                                                    }}
                                                    value={client_hp}
                                                    name="mb_id"
                                                    error={errmsghp}
                                                    disableds={timerflag}
                                                />
                                            </div>

                                            {timerflag === false &&
                                                <div>
                                                    <button
                                                        className='inquiry_num_btn'
                                                        onClick={() => {
                                                            if (client_hp.length < 11) {
                                                                seterrmsghp("연락처가 올바르지 않습니다.")
                                                                return;
                                                            }
                                                            seterrmsghp("");
                                                            setauthNum("")
                                                            let sender2 = {
                                                                hp: client_hp
                                                            }
                                                            APIS.postData('/sendSms', sender2).then(({ data }) => {
                                                                if (data) {
                                                                    setauthNum(data)
                                                                    settimerflag(true);
                                                                } else {
                                                                    seterrmsghp("인증번호 전송에 실패하였습니다. 다시 시도하세요.")
                                                                }
                                                            }).catch(({ response }) => {
                                                                console.log(response);
                                                            }).finally(() => {
                                                            });

                                                        }}
                                                    >
                                                        인증번호 발송
                                                    </button>
                                                </div>
                                            }
                                        </div>

                                        {timerflag === true &&
                                            <div className="inquiry_number_div">
                                                <div className='title'>인증번호</div>

                                                <div className='inquiry_number_input_div'>
                                                    <Input
                                                        className={`inputs`}
                                                        placeholder="인증번호"
                                                        setValue={(v)=>{
                                                            seterrmsg2("")
                                                            setsecretnum(v)
                                                        }}
                                                        value={secretnum}
                                                        name="secretnum"
                                                        timer={authCheck ? false : true}
                                                        timerState={() => {
                                                            seterrmsg2('인증시간이 초과됐습니다. 다시 요청해주세요.');
                                                            settimerflag(false);
                                                        }}
                                                        error={errmsg2}
                                                        disableds={authCheck}
                                                    />
                                                </div>
                                                <div>
                                                    <button
                                                        className='inquiry_num_btn'
                                                        onClick={() => {
                                                            if (authNum == secretnum) {
                                                                setauthCheck(true);
                                                            } else {
                                                                seterrmsg2('인증번호가 올바르지 않습니다.');
                                                            }
                                                        }}
                                                        disabled={authCheck}
                                                    >
                                                        {authCheck ? '인증완료' : '확인'}
                                                    </button>
                                                </div>
                                            </div>
                                        }


                                        <div className="inputviewtype1 ">
                                            <div>특이사항</div>
                                            <div>
                                                <textarea
                                                    placeholder='추후 상세등록 시 필요한 사항들을 작성하시면 매물관리에 도움이 됩니다.ex) 방/욕실 수, 공실여부, 현업종, 상호 등'
                                                    onChange={(e) => {
                                                        setdesc(e.target.value);
                                                    }}
                                                >{desc}</textarea>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        {/* 구해주세요 시작 */}
                                        <div className="productInputarea" >
                                            {/* <div className="inputviewtype1 " style={{ marginTop: 0 }}>
                                                <div>고객명칭<span className='colorF00'>*</span></div>
                                                <div>
                                                    <Input
                                                        className={`inputs`}
                                                        placeholder=""
                                                        setValue={settitle}
                                                        value={title}
                                                        name="mb_phone"
                                                    />
                                                </div>
                                            </div> */}
                                            <div className="inputviewtype1 " >
                                                <div>거래형태<span className='colorF00'>*</span></div>
                                                <div>
                                                    {category_2 * 1 !== 3 &&
                                                        <Button
                                                            buttonTxt={'매매'}
                                                            className={`writeRadiobutton ${sell_type === '매매' ? 'active' : ''}`}
                                                            onPress={() => {
                                                                // if(category_2*1 === 3){
                                                                //     return;
                                                                // }
                                                                setsell_type('매매');
                                                            }}
                                                        />
                                                    }
                                                    <Button
                                                        buttonTxt={'전세'}
                                                        className={`writeRadiobutton ${sell_type === '전세' ? 'active' : ''}`}
                                                        onPress={() => {
                                                            setsell_type('전세');
                                                        }}
                                                    />
                                                    <Button
                                                        buttonTxt={'월세'}
                                                        className={`writeRadiobutton ${sell_type === '월세' ? 'active' : ''}`}
                                                        onPress={() => {
                                                            setsell_type('월세');
                                                        }}
                                                    />

                                                    {category_2 * 1 === 3 &&
                                                        <div className="input_error">* 단독/다가구 매매는 건물-주거전용건물 탭을 이용하세요.</div>
                                                    }
                                                </div>
                                            </div>

                                            <div className="inputviewtype4 " style={{ alignItems: 'flex-start' }}>
                                                <div style={{ marginTop: 0 }}>매물 종류<span className='colorF00'>*</span></div>
                                                <div>
                                                    <div>
                                                        <Radios
                                                            linetype={'radioimg'}
                                                            values={category_1}
                                                            setvalues={(e) => {
                                                                setcategory_1(e * 1);
                                                                setcategory_2(category_2_setting?.filter((x2, i2) => (x2.category_1 * 1 === e * 1))[0]?.values);
                                                            }}
                                                            namevalue={[
                                                                { names: '주거', values: 1 },
                                                                { names: '상업', values: 2 },
                                                                { names: '건물', values: 3 }
                                                            ]}
                                                            fontweights={400}
                                                            fontSizes={14}
                                                            sizes={20}
                                                        />
                                                        {/* configdata?.consts?.bannerPositionOptionConsts */}
                                                    </div>
                                                    <div className='margint8'>
                                                        <Select
                                                            styles={{}}
                                                            setValues={(e) => {
                                                                // if(e*1 === 3){
                                                                //     setsell_type('전세');
                                                                // }
                                                                if (sell_type === '매매' && e * 1 === 3) {
                                                                    setsell_type('전세');
                                                                }

                                                                setcategory_2(e);
                                                            }}
                                                            values={category_2}
                                                            selectData={category_2_setting?.filter((x, i) => x?.category_1 * 1 === category_1 * 1)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="inputviewtype4 " style={{ alignItems: 'flex-start' }}>
                                                <div>희망 지역<span className='colorF00'>*</span></div>
                                                <div>
                                                    <div style={{ gap: 8 }}>
                                                        <Button
                                                            buttonTxt={'목록으로 선택'}
                                                            className={'linenormalbutton'}
                                                            onPress={() => {
                                                                // setcityspopflag(true);

                                                                setIsAddr(!isAddr);
                                                            }}
                                                            styles={{
                                                                width: 100, height: 36, borderRadius: 0,
                                                                fontSize: 14
                                                            }}
                                                        />
                                                    </div>

                                                    {(listselecterviewerlist?.length > 0) &&
                                                        <div className='margint8'>
                                                            <div className='selstickdelarea ' style={{ width: '100%' }}>
                                                                {listselecterviewerlist?.length > 0 && listselecterviewerlist?.map((x, i) => {
                                                                    return (
                                                                        <button
                                                                            type="button" key={i}
                                                                            onClick={() => {
                                                                                setlistselecterviewerlist(listselecterviewerlist?.filter(item => item?.viewernames !== x?.viewernames));
                                                                            }}
                                                                        >
                                                                            {x?.viewernames}
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                                <path fillRule="evenodd" clipRule="evenodd" d="M3.52851 3.52851C3.78886 3.26816 4.21097 3.26816 4.47132 3.52851L7.99992 7.05711L11.5285 3.52851C11.7889 3.26816 12.211 3.26816 12.4713 3.52851C12.7317 3.78886 12.7317 4.21097 12.4713 4.47132L8.94273 7.99992L12.4713 11.5285C12.7317 11.7889 12.7317 12.211 12.4713 12.4713C12.211 12.7317 11.7889 12.7317 11.5285 12.4713L7.99992 8.94273L4.47132 12.4713C4.21097 12.7317 3.78886 12.7317 3.52851 12.4713C3.26816 12.211 3.26816 11.7889 3.52851 11.5285L7.05711 7.99992L3.52851 4.47132C3.26816 4.21097 3.26816 3.78886 3.52851 3.52851Z" fill="#999999" />
                                                                            </svg>
                                                                        </button>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>

                                            <div className="inputviewtype1 ">
                                                <div>{sell_type === '매매' ? '희망매매가' : '희망보증금'}<span className='colorF00'>*</span></div>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <div style={{ width: 'calc(50% - 10px)' }}>
                                                        <Input
                                                            className={`inputs`}
                                                            type={'number'}
                                                            rightplaceholder="만원"
                                                            placeholder=""
                                                            setValue={setprice_all_min}
                                                            value={price_all_min}
                                                            name="mb_phone"
                                                            zerostatus={true}
                                                            style={{
                                                                paddingRight: 40, textAlign: 'right'
                                                            }}
                                                        />
                                                    </div>
                                                    <span>~</span>
                                                    <div style={{ width: 'calc(50% - 10px)' }}>
                                                        <Input
                                                            className={`inputs`}
                                                            type={'number'}
                                                            rightplaceholder="만원"
                                                            placeholder=""
                                                            setValue={setprice_all_max}
                                                            value={price_all_max}
                                                            name="mb_phone"
                                                            zerostatus={true}
                                                            style={{
                                                                paddingRight: 40, textAlign: 'right'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {sell_type === '월세' &&
                                                <div className="inputviewtype1 ">
                                                    <div>희망월세<span className='colorF00'>*</span></div>
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                        <div style={{ width: 'calc(50% - 10px)' }}>
                                                            <Input
                                                                className={`inputs`}
                                                                rightplaceholder="만원"
                                                                type={'number'}
                                                                placeholder=""
                                                                setValue={setprice_month_min}
                                                                value={price_month_min}
                                                                name="mb_phone"
                                                                zerostatus={true}
                                                                style={{
                                                                    paddingRight: 40, textAlign: 'right'
                                                                }}
                                                            />
                                                        </div>
                                                        <span>~</span>
                                                        <div style={{ width: 'calc(50% - 10px)' }}>
                                                            <Input
                                                                className={`inputs`}
                                                                rightplaceholder="만원"
                                                                type={'number'}
                                                                placeholder=""
                                                                setValue={setprice_month_max}
                                                                value={price_month_max}
                                                                name="mb_phone"
                                                                zerostatus={true}
                                                                style={{
                                                                    paddingRight: 40, textAlign: 'right'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {((sell_type === '매매' && (category_2 * 1 === 5 || category_2 * 1 === 6 || category_2 * 1 === 7 || category_2 * 1 === 8)) ||
                                                (sell_type !== '매매' && (category_2 * 1 === 5 || category_2 * 1 === 6 || category_2 * 1 === 7 || category_2 * 1 === 8 || category_2 * 1 === 9))) &&
                                                <div className="inputviewtype1 ">
                                                    <div>권리금</div>
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                        <div style={{ width: 'calc(50% - 10px)' }}>
                                                            <Input
                                                                className={`inputs`}
                                                                type={'number'}
                                                                rightplaceholder="만원"
                                                                placeholder=""
                                                                setValue={setprice_key_min}
                                                                value={price_key_min}
                                                                name="mb_phone"
                                                                zerostatus={true}
                                                                style={{
                                                                    paddingRight: 40, textAlign: 'right'
                                                                }}
                                                            />
                                                        </div>
                                                        <span>~</span>
                                                        <div style={{ width: 'calc(50% - 10px)' }}>
                                                            <Input
                                                                className={`inputs`}
                                                                type={'number'}
                                                                rightplaceholder="만원"
                                                                placeholder=""
                                                                setValue={setprice_key_max}
                                                                value={price_key_max}
                                                                name="mb_phone"
                                                                zerostatus={true}
                                                                style={{
                                                                    paddingRight: 40, textAlign: 'right'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            <div className='margint12 color666'>
                                                거래에 필요한 실제 금액을 입력하시면 매칭에 도움이 됩니다.<br />
                                                매매: 매매가-현보증금 / 임대: 보증금 (+권리금)
                                            </div>

                                            {/* <div className="inputviewtype1 ">
                                                <div>실투자금</div>
                                                <div>
                                                    <Input
                                                        className={`inputs`}
                                                        type={'number'}
                                                        rightplaceholder="만원"
                                                        placeholder=""
                                                        setValue={setprice_real}
                                                        value={price_real}
                                                        name="mb_phone"
                                                        zerostatus={true}
                                                        style={{
                                                            paddingRight: 40, textAlign: 'right'
                                                        }}
                                                    />
                                                </div>
                                            </div> */}
                                            <div className="inputviewtype1 ">
                                                <div>희망 층수</div>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <div style={{ width: 'calc(50% - 10px)' }}>
                                                        <Input
                                                            className={`inputs`}
                                                            type={'number'}
                                                            rightplaceholder="층"
                                                            placeholder=""
                                                            setValue={setitem_floor_min}
                                                            value={item_floor_min}
                                                            name="mb_phone"
                                                            zerostatus={true}
                                                            style={{
                                                                paddingRight: 30, textAlign: 'right'
                                                            }}
                                                        />
                                                    </div>
                                                    <span>~</span>
                                                    <div style={{ width: 'calc(50% - 10px)' }}>
                                                        <Input
                                                            className={`inputs`}
                                                            type={'number'}
                                                            rightplaceholder="층"
                                                            placeholder=""
                                                            setValue={setitem_floor_max}
                                                            value={item_floor_max}
                                                            name="mb_phone"
                                                            zerostatus={true}
                                                            style={{
                                                                paddingRight: 30, textAlign: 'right'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="inputviewtype1 ">
                                                <div>희망 면적</div>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <div style={{ width: 'calc(50% - 10px)' }}>
                                                        <Input
                                                            className={`inputs`}
                                                            type={'number'}
                                                            // rightplaceholder="㎡"
                                                            rightplaceholder="평"
                                                            placeholder=""
                                                            setValue={setitem_area_min}
                                                            value={item_area_min}
                                                            name="mb_phone"
                                                            zerostatus={true}
                                                            style={{
                                                                paddingRight: 34, textAlign: 'right'
                                                            }}
                                                        />
                                                    </div>
                                                    <span>~</span>
                                                    <div style={{ width: 'calc(50% - 10px)' }}>
                                                        <Input
                                                            className={`inputs`}
                                                            type={'number'}
                                                            // rightplaceholder="㎡"
                                                            rightplaceholder="평"
                                                            placeholder=""
                                                            setValue={setitem_area_max}
                                                            value={item_area_max}
                                                            name="mb_phone"
                                                            zerostatus={true}
                                                            style={{
                                                                paddingRight: 34, textAlign: 'right'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="inputviewtype1 ">
                                                <div>희망 연식</div>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <div style={{ width: 'calc(50% - 10px)' }}>
                                                        <Input
                                                            className={`inputs`}
                                                            rightplaceholder="년"
                                                            placeholder="yyyy"
                                                            setValue={setitem_year_min}
                                                            value={item_year_min}
                                                            onBlur={() => {
                                                                if (item_year_min?.length < 4) {
                                                                    setdateerrmsg('희망연식을 확인해주세요.');
                                                                    return;
                                                                }

                                                                let dates = `${item_year_min}-01-01`;
                                                                if (moment(dates).format('YYYY') === 'Invalid date') {
                                                                    setdateerrmsg('희망연식을 확인해주세요.');
                                                                } else {
                                                                    setdateerrmsg('');
                                                                    setitem_year_min(moment(dates).format('YYYY'));
                                                                }
                                                            }}

                                                            name="mb_phone"
                                                            zerostatus={true}
                                                            style={{
                                                                paddingRight: 30, textAlign: 'right'
                                                            }}
                                                        />
                                                        {dateerrmsg !== '' && <div className='err' style={{ color: 'red' }}>{dateerrmsg}</div>}
                                                    </div>
                                                    <span>~</span>
                                                    <div style={{ width: 'calc(50% - 10px)' }}>
                                                        <Input
                                                            className={`inputs`}
                                                            rightplaceholder="년"
                                                            placeholder="yyyy"
                                                            setValue={setitem_year_max}
                                                            value={item_year_max}
                                                            onBlur={() => {
                                                                if (item_year_max?.length < 4) {
                                                                    setdateerrmsg('희망연식을 확인해주세요.');
                                                                    return;
                                                                }
                                                                let dates = `${item_year_max}-01-01`;
                                                                if (moment(dates).format('YYYY') === 'Invalid date') {
                                                                    setdateerrmsg('희망연식을 확인해주세요.');
                                                                } else {
                                                                    setdateerrmsg('');
                                                                    setitem_year_max(moment(dates).format('YYYY'));
                                                                }
                                                            }}
                                                            maxlength={4}
                                                            name="mb_phone"
                                                            zerostatus={true}
                                                            style={{
                                                                paddingRight: 30, textAlign: 'right'
                                                            }}
                                                        />
                                                        {dateerrmsg !== '' && <div className='err' style={{ color: '#fff' }}>asdfasdf</div>}
                                                    </div>
                                                </div>
                                            </div> */}

                                            {/* <div className="inputviewtype2 ">
                                                <div>입주시기<span className='colorF00'>*</span></div>
                                                <div>
                                                    <div style={{ width: '100%' }}>
                                                        <div style={{ width: '100%' }}>
                                                            <InputDate
                                                                type="text" placeholder="yymmdd" name="ipd1"
                                                                dateValue={in_year}
                                                                setDateValue={setin_year}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <Checkbox
                                                            linetype={'checkimg'}
                                                            values={checkvalues}
                                                            setvalues={setcheckvalues}
                                                            namevalue={[
                                                                { names: '협의가능', values: 0 },
                                                                { names: '상관없음', values: 1 },
                                                            ]}
                                                            fontweights={400}
                                                            fontSizes={14}
                                                            sizes={20}
                                                        />
                                                    </div>
                                                </div>
                                            </div> */}

                                            <div className="inquiry_number_div">
                                                <div className='title'>연락처<span className='colorF00'>*</span></div>

                                                <div className='inquiry_number_input_div'>
                                                    <Input
                                                        className={`inputs`}
                                                        setValue={(v) => {
                                                            seterrmsghp("");
                                                            setclient_hp(v)
                                                        }}
                                                        value={client_hp}
                                                        name="mb_id"
                                                        error={errmsghp}
                                                        disableds={timerflag}
                                                    />
                                                </div>

                                                {timerflag === false &&
                                                    <div>
                                                    <button
                                                        className='inquiry_num_btn'
                                                        onClick={() => {
                                                            if (client_hp.length < 11) {
                                                                seterrmsghp("연락처가 올바르지 않습니다.")
                                                                return;
                                                            }
                                                            seterrmsghp("");
                                                            setauthNum("")
                                                            let sender2 = {
                                                                hp: client_hp
                                                            }
                                                            APIS.postData('/sendSms', sender2).then(({ data }) => {
                                                                if (data) {
                                                                    setauthNum(data)
                                                                    settimerflag(true);
                                                                } else {
                                                                    seterrmsghp("인증번호 전송에 실패하였습니다. 다시 시도하세요.")
                                                                }
                                                            }).catch(({ response }) => {
                                                                console.log(response);
                                                            }).finally(() => {
                                                            });

                                                        }}
                                                    >
                                                        인증번호 발송
                                                    </button>
                                                </div>}
                                            </div>
                                            {timerflag === true &&
                                                <div className="inquiry_number_div">
                                                    <div className='title'>인증번호</div>

                                                    <div className='inquiry_number_input_div'>
                                                        <Input
                                                            className={`inputs`}
                                                            placeholder="인증번호"
                                                            setValue={(v)=>{
                                                                seterrmsg2("")
                                                                setsecretnum(v)
                                                            }}
                                                            value={secretnum}
                                                            name="secretnum"
                                                            timer={authCheck ? false : true}
                                                            timerState={() => {
                                                                seterrmsg2('인증시간이 초과됐습니다. 다시 요청해주세요.');
                                                                settimerflag(false);
                                                            }}
                                                            error={errmsg2}
                                                            disableds={authCheck}
                                                        />
                                                    </div>
                                                    <div>
                                                        <button
                                                            className='inquiry_num_btn'
                                                            onClick={() => {
                                                                if (authNum == secretnum) {
                                                                    setauthCheck(true);
                                                                } else {
                                                                    seterrmsg2('인증번호가 올바르지 않습니다.');
                                                                }
                                                            }}
                                                            disabled={authCheck}
                                                        >
                                                            {authCheck ? '인증완료' : '확인'}
                                                        </button>
                                                    </div>
                                                </div>
                                            }


                                            <div className="inputviewtype1 ">
                                                <div>하고싶은말</div>
                                                <div>
                                                    <textarea
                                                        placeholder='부동산에서 꼭 참고해야 하는 내용을 작성해주세요. 원하시는 매물을 찾는데 큰 도움이 됩니다.'
                                                        onChange={(e) => {
                                                            setmemo(e.target.value);
                                                        }}
                                                        value={memo}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }


                                <div className='quetion_bottom02'>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 4
                                        }}
                                    >
                                        <PolicyContents
                                            checked={quetion_check}
                                            setChecked={setquetion_check}
                                            companyName={memberinfos?.compony?.title}
                                        />
                                        {/* <Checkbox
                                            linetype={'checkimg'}
                                            values={quetion_check}
                                            setvalues={(e) => {
                                                // console.log(e);
                                                setquetion_check(e);
                                            }}
                                            namevalue={[
                                                { names: '(필수) 개인정보 수집/이용에 동의합니다.', values: 1 },
                                            ]}
                                            fontweights={400}
                                            fontSizes={14}
                                            sizes={20}
                                        />
                                        <Checkbox
                                            linetype={'checkimg'}
                                            values={quetion_check2}
                                            setvalues={(e) => {
                                                // console.log(e);
                                                setquetion_check2(e);
                                            }}
                                            namevalue={[
                                                {
                                                    names: <span>
                                                        (필수) <span className="links" href="/Agree2" target='_blank' onClick={e => {
                                                            e.stopPropagation()
                                                            window.open("/Agree2", "_blank")
                                                        }}>개인정보 업무처리</span> 위탁에 동의합니다.
                                                    </span>,
                                                    values: 1
                                                }
                                            ]}
                                            fontweights={400}
                                            fontSizes={14}
                                            sizes={20}
                                        /> */}
                                    </div>

                                    {/* <div style={{ height: 1, backgroundColor: '#eee', marginTop: 4, marginBottom: 4 }} /> */}

                                    {/* {bottomText?.map((x, i) => {
                                        return (
                                            <div className='quetion_bottom_text'>
                                                <div className='text_box'>
                                                    <div className='ball' />
                                                    <p>{x?.title}</p>
                                                </div>

                                                {x?.text &&
                                                    <div className='text_box'>
                                                        <div className='ball' style={{ backgroundColor: '#F1F1F1' }}/>
                                                        <p style={{ fontWeight: 700 }}>{x?.text}</p>
                                                    </div>
                                                }
                                            </div>
                                        )
                                    })} */}
                                </div>

                                <div className="input_error">{errmsg}</div>
                                <div
                                    className='margint20'
                                    style={{
                                        display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8
                                    }}
                                >
                                    <div style={{ width: '50%' }}>
                                        <Button
                                            buttonTxt={'문의하기'}
                                            styles={{}}
                                            onPress={() => {
                                                // quetion_type => 1=매물내놓기, 2=구해주세요
                                                if (quetion_type * 1 === 2) {
                                                    customerWirteSubmit();
                                                } else {
                                                    simpleWirteSubmit();
                                                }
                                            }}
                                        />
                                    </div>

                                    <div style={{ width: '50%' }}>
                                        <Button
                                            buttonTxt={'취소'}
                                            disabled={true}
                                            onPress={() => {
                                                if (setView) setView();
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            :
                            <div className='addr_select_div'>

                                <div className='addr_select_flex_top'>
                                    <p>희망지역</p>
                                    <img src="./images/icons/x.svg"
                                        onClick={() => {
                                            setIsAddr(!isAddr);
                                        }}
                                    />
                                </div>

                                <div className="filteraddrarea">
                                    <div></div>
                                    <AddrSelector
                                        listselecterviewerlist={listselecterviewerlist}
                                        setlistselecterviewerlist={setlistselecterviewerlist}
                                    />
                                </div>

                                <div className='selstickdelarea margint20'>
                                    {listselecterviewerlist?.length > 0 && listselecterviewerlist?.map((x, i) => {
                                        return (
                                            <button type="button"
                                                key={i}
                                                onClick={() => {
                                                    setlistselecterviewerlist(listselecterviewerlist?.filter(item => item?.viewernames !== x?.viewernames));
                                                }}
                                            >
                                                {x?.viewernames}
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M3.52851 3.52851C3.78886 3.26816 4.21097 3.26816 4.47132 3.52851L7.99992 7.05711L11.5285 3.52851C11.7889 3.26816 12.211 3.26816 12.4713 3.52851C12.7317 3.78886 12.7317 4.21097 12.4713 4.47132L8.94273 7.99992L12.4713 11.5285C12.7317 11.7889 12.7317 12.211 12.4713 12.4713C12.211 12.7317 11.7889 12.7317 11.5285 12.4713L7.99992 8.94273L4.47132 12.4713C4.21097 12.7317 3.78886 12.7317 3.52851 12.4713C3.26816 12.211 3.26816 11.7889 3.52851 11.5285L7.05711 7.99992L3.52851 4.47132C3.26816 4.21097 3.26816 3.78886 3.52851 3.52851Z" fill="#999999" />
                                                </svg>
                                            </button>
                                        );
                                    })}
                                </div>

                                <div style={{ marginTop: 20, marginBottom: 20, height: 1, backgroundColor: '#eee' }} />

                                <div className="filterbuttonsarea">
                                    <div>
                                        <Button
                                            onPress={() => {
                                                setIsAddr(!isAddr);
                                            }}
                                            buttonTxt={'등록하기'}
                                        />
                                    </div>
                                    <div>
                                        <Button
                                            titleimgs={`./images/icons/loop-left-line-purple.svg`}
                                            buttonTxt={'초기화'}
                                            className={'linenormalbutton'}
                                            onPress={() => {
                                                setlistselecterviewerlist([]);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>




                    {/* {quetion_type === 2 &&
                        <div className='selstickdelarea02'>
                            {reallistselecterviewerlist?.length > 0 && reallistselecterviewerlist?.map((x, i) => {
                                return (
                                    <button type="button" 
                                        key={i}
                                        onClick={() => {
                                            setreallistselecterviewerlist(reallistselecterviewerlist?.filter(item => item?.viewernames !== x?.viewernames));  
                                        }}                                                    
                                    >
                                        {x?.viewernames}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M3.52851 3.52851C3.78886 3.26816 4.21097 3.26816 4.47132 3.52851L7.99992 7.05711L11.5285 3.52851C11.7889 3.26816 12.211 3.26816 12.4713 3.52851C12.7317 3.78886 12.7317 4.21097 12.4713 4.47132L8.94273 7.99992L12.4713 11.5285C12.7317 11.7889 12.7317 12.211 12.4713 12.4713C12.211 12.7317 11.7889 12.7317 11.5285 12.4713L7.99992 8.94273L4.47132 12.4713C4.21097 12.7317 3.78886 12.7317 3.52851 12.4713C3.26816 12.211 3.26816 11.7889 3.52851 11.5285L7.05711 7.99992L3.52851 4.47132C3.26816 4.21097 3.26816 3.78886 3.52851 3.52851Z" fill="#999999"/>
                                        </svg>                                
                                    </button>
                                );
                            })}
                        </div>  
                    } */}
                    <div></div>
                </div>
            </div>
        </>
    )
}